import React, { useContext } from "react";
import "./Intro.css";
import { themeContext } from "../../Context";
import UilLinkedin from "@iconscout/react-unicons/icons/uil-linkedin";
import UilGithub from "@iconscout/react-unicons/icons/uil-github";
import * as Unicons from '@iconscout/react-unicons';
import { useData } from "../../DataContext";
import Portfolio from "../Portfolio/Portfolio";
import upwork from '../../img/Upwork.png';
const Intro = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const { userData } = useData()

  const skillData = (item, index) => {
    return (
      <li key={index.toString()} className="i-listtext">{item}</li>
    )
  }

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          {/* yahan change hy darkmode ka */}
          <span style={{ color: darkMode ? "white" : "" }}>Hi, I Am</span>
          <span>{userData?.name} {userData?.last_name}</span>
          <span>
            {userData?.about}
          </span>
          <div style={{ flexDirection: 'row' }}>
            <span>Contact Me: </span>
            <a className="f-mail" href={`mailto:${userData.email}`} style={{ textDecoration: 'none' }} >{userData?.email}</a>
          </div>
        </div>
        <div className="i-icons">
          {userData?.skype && <Unicons.UilSkype className="i-logo" onClick={() => { window.open(userData?.skype, '_blank'); }} size={"2rem"}/>}
          {userData?.linkedin && <UilLinkedin className="i-logo" onClick={() => { window.open(userData?.linkedin, '_blank'); }} size={"2rem"} />}
          {userData?.github && <UilGithub className="i-logo" onClick={() => { window.open(userData?.github, '_blank'); }} size={"2rem"} />}
          {userData?.upwork && <img onClick={() => { window.open(userData?.upwork, '_blank'); }} style={{ height: 50, width: 50, marginLeft: 5 }} src={upwork} alt=""/>}
        </div>
        <div className="i-experinece">
          <span>Experience</span>
        </div>
        <h3 id="skills">Skills</h3>
        <ul >
          {userData?.skills.map((item, index) => skillData(item, index))}
        </ul>
        {userData?.freelance && <>
          <h3 id="skills">Freelance</h3>
          <p >{userData?.freelance}</p>
        </>
        }
        {userData?.employement && <>
          <h3 id="skills">Full time employment</h3>
          <p className="i-listtext">{userData?.employement}</p>
        </>}
        <div className="i-experinece">
          <span>Education</span>
        </div>
        <p className="i-listtext">{userData?.education}</p>

        <Portfolio />


      </div>
    </div>
  );
};

export default Intro;
